import { Doc, DocPath } from "@/components/Doc/Doc";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { InputSelect } from "@/components/_pages/ModelPage/Sidebar/InputSelect";
import { Group } from "@mantine/core";
import { PrimitiveAtom, useAtom } from "jotai";
import { InputToggle } from "../../../Sidebar/InputToggle";

export const EquityTreatmentToggle = ({
  label,
  docPath,
  applyStepUpAtom,
  equityModeAtom,
  disabled = false,
  visible = true,
}: {
  label: string;
  docPath: DocPath;
  applyStepUpAtom: PrimitiveAtom<boolean>;
  equityModeAtom: PrimitiveAtom<"preferred" | "common">;
  disabled?: boolean;
  visible?: boolean;
}) => {
  const [applyStepUp, setApplyStepUp] = useAtom(applyStepUpAtom);
  const [equityMode, setEquityMode] = useAtom(equityModeAtom);

  if (!visible) {
    return null;
  }

  return (
    <>
      <InputSelect
        disabled={disabled}
        labelWidth={148}
        label={
          <LabelExplainer label={label} explanation={<Doc path={docPath} />} />
        }
        data={[
          { value: "preferred", label: "Preferred Equity" },
          { value: "common", label: "Common Equity" },
        ]}
        value={equityMode}
        onChange={(value) => {
          setEquityMode(value as "preferred" | "common");
        }}
        styles={{
          input: {
            background: disabled ? "gray.1" : "transparent",
            color: "black",
            opacity: 1,
          },
          section: {
            opacity: disabled ? 0 : 1,
          },
        }}
      />
      <Group
        justify="right"
        pos={"relative"}
        top={-9}
        h={26}
        opacity={equityMode === "common" ? 0.3 : 1}
      >
        <InputToggle
          size="xs"
          labelWidth={108}
          gap={0}
          label={
            <LabelExplainer
              label={
                <>
                  <span
                    style={{
                      textDecoration:
                        equityMode === "common" ? "line-through" : "none",
                    }}
                  >
                    Equity Step-Up?
                  </span>
                </>
              }
              explanation={
                <Doc
                  path={
                    "@/docs/pages/model/sidebar/equityTermsApplyEquityStepUp.mdx"
                  }
                />
              }
            />
          }
          checked={equityMode === "common" ? false : applyStepUp}
          onChange={(event) => {
            setApplyStepUp(event.currentTarget.checked);
          }}
          disabled={equityMode === "common"}
        />
      </Group>
    </>
  );
};
